import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject } from 'rxjs';

@Component({
  selector: 'yard-cargo-in-position-condition-editor',
  standalone: false,
  templateUrl: './cargo-in-position-condition-editor.component.html',
  styleUrl: './cargo-in-position-condition-editor.component.scss',
})
export class CargoInPositionConditionEditorComponent implements OnInit,  ConditionEditorContextConsumer {

  condition: ConditionEntry;

  formGroup = new FormGroup({
    value: new FormControl(null, [])
  });

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        this.formGroup.patchValue({ value: condition.data });
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe(value => {
      this.condition.data = value.value;
    });
  }

}
